import { motion } from "framer-motion";

export const FrameExtraction = () => {
  return (
    <section className="min-h-[70vh] flex items-center relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="space-y-4"
        >
          <p className="text-2xl md:text-3xl lg:text-4xl text-muted-foreground leading-relaxed">
            What if one piece of praise
          </p>
          <p className="font-editorial text-4xl md:text-5xl lg:text-6xl text-foreground">
            became content for every platform?
          </p>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-2xl md:text-3xl text-brand-600 font-editorial"
          >
            In 60 seconds.
          </motion.p>
        </motion.div>

        <motion.div
          className="mt-16 h-px w-full max-w-md mx-auto bg-gradient-to-r from-transparent via-brand-600/60 to-transparent"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.8 }}
        />
      </div>
    </section>
  );
};
